<template>
  <div class="price-table">
    <ul>
      <li class="top">
        <div class="box"><span>{{langPurchase.pricelist[0]}}</span></div>
        <div class="box"><span>{{langPurchase.pricelist[1]}}</span></div>
        <div class="price">
          <div class="shang">{{langPurchase.pricelist[2]}}</div>
          <div class="xia">
            <div>{{langPurchase.pricelist[3]}}</div>
            <div>{{langPurchase.pricelist[4]}}</div>
          </div>
        </div>
      </li>
      <li class="t-middle">
        <div class="box thin"><span>{{langPurchase.pricelist[5]}}</span></div>
        <div class="box thin"><span>{{langPurchase.pricelist[6]}}</span></div>
        <div class="box thin price"><span v-html="langPurchase.pricelist[7]"></span></div>
      </li>
      <li class="t-bottom">
        <div class="box big-box"><span>{{langPurchase.pricelist[8]}}</span></div>
        <div class="box big-box big-list">
          <div class="thin"><span>{{langPurchase.pricelist[9]}}</span></div>
          <div class="thin"><span>{{langPurchase.pricelist[10]}}</span></div>
          <div class="thin"><span>{{langPurchase.pricelist[11]}}</span></div>
          <div class="thin"><span>{{langPurchase.pricelist[12]}}</span></div>
        </div>
        <div class="box big-box long big-list">
          <div class="thin"><span :style="{minWidth:language==='en'?'68%':'60%'}">{{langPurchase.pricelist[13+type]}}</span></div>
          <div class="thin"><span :style="{minWidth:language==='en'?'68%':'60%'}">{{langPurchase.pricelist[14+type]}}</span></div>
          <div class="thin"><span :style="{minWidth:language==='en'?'68%':'60%'}">{{langPurchase.pricelist[15+type]}}</span></div>
          <div class="thin"><span :style="{minWidth:language==='en'?'68%':'60%'}">{{langPurchase.pricelist[16+type]}}</span></div>
        </div>
        <div class="box big-box long big-list">
          <div class="thin"><span :style="{minWidth:language==='en'?'68%':'60%'}">{{langPurchase.pricelist[17+type]}}</span></div>
          <div class="thin"><span :style="{minWidth:language==='en'?'68%':'60%'}">{{langPurchase.pricelist[18+type]}}</span></div>
          <div class="thin"><span :style="{minWidth:language==='en'?'68%':'60%'}">{{langPurchase.pricelist[19+type]}}</span></div>
          <div class="thin"><span :style="{minWidth:language==='en'?'68%':'60%'}">{{langPurchase.pricelist[20+type]}}</span></div>
        </div>
      </li>
      <li class="t-sub">
        <div class="box thin"><span>{{langPurchase.pricelist[21]}}</span></div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      langPurchase: state => state.language.home.purchase,
      language: state => state.language.current
    })
  }
}
</script>

<style lang="scss" scoped>
.price-table{
  box-sizing:border-box;
  border-top: 1px solid #e7e7e7;
  border-left: 1px solid #e7e7e7;
  width: 621px;
  .box{
    width: 130px;
    height: 100px;
    display: inline-block;
    vertical-align: top;
    font-size: 16px;
    border-right: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
    position: relative;
    >span{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      display: inline-block;
    }
  }

  .big-box{
    height: 200px;
    >span{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      display: inline-block;
    }
  }
  .big-list{
    div{
      border-bottom: 1px solid #e7e7e7;
    }
  }

  .thin{
    height: 50px;
    position: relative;
     >span{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      display: inline-block;
    }
  }
  .long{
    width: 180px;
    .thin{
      line-height: 50px;
      span{
        display: inline-block;
        text-align: left;
        min-width: 60%;
        transform: translateX(10%);
        position: static;
        width: auto;
      }
  }
  }
  .price{
    width: 360px;
    font-size: 16px;
    display: inline-block;
    vertical-align: top;
    border-right: 1px solid #e7e7e7;
    .shang{
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #e7e7e7;
    }
    .xia{
      height: 50px;
      line-height: 50px;
      display: flex;
      border-bottom: 1px solid #e7e7e7;
      justify-content: space-around;
      div{
        width: 50%;
        &:first-of-type{
          border-right: 1px solid #e7e7e7;
        }
      }
    }
  }

  .top,.t-middle,.t-bottom,.t-sub{
    width: 100%;
    font-size: 0;
  }
  .t-sub{
    .box{
      width: 100%;
    }
  }
  .t-middle{
    >div{
      background-color: #f4f4f4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/priceTable/index.vue